import React from 'react';

export default function ReportModal({ isOpen, onClose }) {
  const email = "mohamedzindha21@gmail.com";

  const copyToClipboard = () => {
    navigator.clipboard.writeText(email);
    alert("Email copied to clipboard!");
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md p-6">
        <h2 className="text-xl font-bold mb-4">Report a Copyright Violation</h2>
        <p className="text-gray-700 mb-4">
          To report a copyright issue, please send us an email with details about the content in question.
        </p>
        <div className="bg-gray-100 rounded px-3 py-2 flex items-center justify-between mb-4">
          <span className="text-gray-800 font-mono">{email}</span>
          <button
            onClick={copyToClipboard}
            className="text-sm text-blue-600 hover:underline ml-4"
          >
            Copy
          </button>
        </div>
        <div className="text-right">
          <button
            onClick={onClose}
            className="text-sm text-gray-600 hover:underline"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
